// extracted by mini-css-extract-plugin
export var icon = "_4u-1";
export var subtext = "_4u-0";